import rogl_CardioForm from "./pages/OnegenLab/CardioForm";
import rogl_InjuriesForm from "./pages/OnegenLab/InjuriesForm";
import rogl_CapilarForm from "./pages/OnegenLab/CapilarForm";
import rogl_CellulitisForm from "./pages/OnegenLab/CellulitisForm";
import rogl_IntoleranceForm from "./pages/OnegenLab/IntoleranceForm";
import rogl_NutritionForm from "./pages/OnegenLab/NutritionForm";
import rogl_NutritionBabyTeensForm from "./pages/OnegenLab/NutritionBabyTeensForm";
import rogl_SportsForm from "./pages/OnegenLab/SportsForm";
import rogl_SkinForm from "./pages/OnegenLab/SkinForm";
import rogl_HomePage from "./pages/OnegenLab/HomePage";
import rppg_HomePage from "./pages/PeopleGenetics/HomePage";
import rppg_CapilarForm from "./pages/PeopleGenetics/CapilarForm";
import rog01_SkinForm from "./pages/Onegen01/SkinForm";
import rog01_AnimalDiseases from "./pages/OnegenLab/AnimalDiseases";
import VueRouter from "vue-router";
import Vue from "vue";

Vue.use(VueRouter);

const routes = {
    "register.onegenlab.com": [
        {
            path: "/nutrition",
            component: rogl_NutritionForm,
            name: "nutrition-form"
        },
        {
            path: "/nutrition-baby-teens",
            component: rogl_NutritionBabyTeensForm,
            name: "nutrition-baby-teens-form"
        },
        {
            path: "/sports",
            component: rogl_SportsForm,
            name: "sports-form"
        },
        { path: "/skin", component: rogl_SkinForm, name: "skin-form" },
        {
            path: "/cellulitis",
            component: rogl_CellulitisForm,
            name: "cellulitis-form"
        },
        {
            path: "/intolerance",
            component: rogl_IntoleranceForm,
            name: "intolerance-form"
        },
        {
            path: "/capilar",
            component: rogl_CapilarForm,
            name: "capilar-form"
        },
        {
            path: "/injuries",
            component: rogl_InjuriesForm,
            name: "injuries-form"
        },
        {
            path: "/cardio",
            component: rogl_CardioForm,
            name: "cardio-form"
        },
        {
            path: "/animal-diseases",
            component: rog01_AnimalDiseases,
            name: "animal-diseases"
        },
        { path: "/", component: rogl_HomePage, name: "home" }
    ],
    "registro.people-genetics.com": [
        { path: "/", component: rppg_HomePage, name: "home" },
        { path: "/capilar", component: rppg_CapilarForm, name: "capilar-form" }
    ],
    "register.onegen01.com": [
        { path: "/", component: rog01_SkinForm, name: "home" }
    ]
};

let host = window.location.host.toLowerCase();
host = host.replace(".wip", "");

if (!routes.hasOwnProperty(host)) {
    host = "register.onegenlab.com";
}

export default new VueRouter({
    routes: routes[host],
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition;
        } else {
            return { x: 0, y: 0 };
        }
    }
});
